import { BUSINESS_SEGMENT_PAGE } from "@/data/marketing/segmentPages";
import SegmentLandingPage from "./SegmentLandingPage";

const HelpGenieForBusinessPage = () => {
  return <SegmentLandingPage content={BUSINESS_SEGMENT_PAGE} />;
};

export default HelpGenieForBusinessPage;
